// @ts-strict-ignore
import { FilterAction } from '@components/_product-overview/reducer'
import { Radio, breakpoints } from '@gassan-ui'
import { motion } from 'framer-motion'
import { useTranslation } from 'next-i18next'
import { rem } from 'polished'
import React, { FC, useRef } from 'react'
import styled from 'styled-components'

const Backdrop = styled(motion.div)`
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  cursor: pointer;
  z-index: ${(p) => p.theme.zIndices.mobileFilters.backdrop};
`

const Dropdown = styled(motion.div)`
  position: absolute;
  width: 100%;
  bottom: 0;
  z-index: 1;
  cursor: initial;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  background: #fff;
  padding: 1.5rem;
  padding-bottom: calc(env(safe-area-inset-bottom) + ${rem(40)});

  @media screen and (min-width: ${breakpoints.small}) {
    padding: 2.5rem;
    padding-bottom: calc(env(safe-area-inset-bottom) + ${rem(80)});
  }
`

type Props = {
  onRequestClose?: () => void
  dispatch: React.Dispatch<FilterAction>
  sort: string
}

const Sort: FC<Props> = ({ onRequestClose, sort, dispatch }) => {
  const ref = useRef<HTMLDivElement>()
  const { t } = useTranslation('filters')
  const handleBackdropClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (ref.current === e.target) {
      onRequestClose()
    }
  }

  return (
    <Backdrop
      ref={ref}
      onClick={handleBackdropClick}
      key="sort-backdrop"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.1 }}
    >
      <Dropdown
        onClick={handleBackdropClick}
        initial={{ y: '100%' }}
        animate={{ y: 0 }}
        exit={{ y: '100%' }}
        transition={{ delay: 0.1, ease: 'easeOut', duration: 0.2 }}
      >
        <Radio
          name="sort"
          id="default"
          label={t('popularity')}
          checked={sort === 'populair'}
          onChange={() => {
            onRequestClose()
            dispatch({ type: 'set-sort', sort: 'populair' })
          }}
        />
        <Radio
          name="sort"
          id="new"
          label={t('newestFirst')}
          checked={sort === 'new'}
          onChange={() => {
            onRequestClose()
            dispatch({ type: 'set-sort', sort: 'new' })
          }}
        />
        <Radio
          name="sort"
          id="priceASC"
          label={t('priceASC')}
          checked={sort === 'priceASC'}
          onChange={() => {
            onRequestClose()
            dispatch({ type: 'set-sort', sort: 'priceASC' })
          }}
        />
        <Radio
          name="sort"
          id="priceDESC"
          label={t('priceDESC')}
          checked={sort === 'priceDESC'}
          onChange={() => {
            onRequestClose()
            dispatch({ type: 'set-sort', sort: 'priceDESC' })
          }}
        />
      </Dropdown>
    </Backdrop>
  )
}

export default Sort
